export const colors = {
  light_blue_300: "#4FC3F7",
  blue_300: "#64B5F6",
  light_blue_100: "#B3E5FC",

  green_100: "#C8E6C9",
  green_300: "#81C784",
  green_500: "#4CAF50",
  persian_green: "#00a79c",

  orange_300: "#FFB74D",
  deep_orange_100: "#FFCCBC",
  deep_orange_300: "#FF8A65",
  pink_100: "#F8BBD0",
  red_100: "#FFCDD2",
  red_300: "#E57373",
  red_400: "#EF5350",
  red_500: "#F44336",

  deep_purple_100: "#D1C4E9",
  indigo_200: "#9FA8DA",
  indigo_300: "#7986CB",
  blue_900: "#0D47A1",

  blue_grey_100: "#CFD8DC",
  gallery: "#EEEEEE",
  grey_100: "#F5F5F5",
  grey_200: "#EEEEEE",
  grey_300: "#E0E0E0",
  grey_700: "#616161",
  grey_800: "#424242",
  grey_900: "#212121",
};
